export default function MainContent({ children }) {
  return <div className="main-content flex flex-col justify-between relative z-10">{children}</div>;
}
